import { createContext, useContext } from "react";

export type PredictionGame = "up-down" | "high-low" | "even-odd";

export const GameContext = createContext<PredictionGame>("high-low");
export const useGameContext = () => useContext(GameContext);
